export class ModalModel {
    public isVisible: boolean;
    public title: string;
    public text: string;
    public declineText: string;
    public acceptText: string;

    constructor(
        isVisible: boolean = false,
        title: string = 'Are you sure?',
        text: string = '',
        declineText: string = 'cancel',
        acceptText: string = 'accept'
    ) {
        this.isVisible = isVisible;
        this.title = title;
        this.text = text;
        this.declineText = declineText;
        this.acceptText = acceptText;
    }

    open(): void {
        this.isVisible = true;
    }

    close(): void {
        this.isVisible = false;
    }
}
